/**
 * * 分离的选择器
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
* */
import React, {Component} from 'react';
import Lang from "@components/Lang/Lang";
import { Select } from "antd";
import "./index.less";

export default class SeparateSelect extends Component {
    static defaultProps = {
        list:[],
        keyValue:"value",
        keyLabel:"label"
    }
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            optionList:[],
            hasList:[],
        }
    }
    // 多选下是数组
    handleChange(values=[], options=[]){
        // console.log("多选下是数组value",value,options)
        if(values.length>0&&options.length>0) {
            const value = values[0], option = options[0];
            let {hasList, valueList} = this.state;
            // console.log("多选下是数组valueList",valueList,option)
            const inx = valueList.findIndex(item => item == value);
            if (inx < 0) {
                hasList.push({
                    value: option.value,
                    label: option.label,
                })
                valueList.push(value)
                if(this.props.onChangeBack)this.props.onChangeBack(valueList);
                this.setState({
                    hasList: hasList,
                    valueList: valueList,
                })
            }
        }
    }
    handleDelete(value){
        let { valueList,hasList } = this.state;
        valueList = valueList.filter(item=>item!==value);
        hasList = hasList.filter(item=>item.value!==value);
        if(this.props.onChangeBack){
            this.props.onChangeBack(valueList)
        }
        this.setState({
            valueList : valueList,
            hasList:hasList
        })
    }
    componentDidMount() {
        const {list,keyValue,keyLabel} = this.props;
        let children = [];
        let hasList = [];
        let valueList = [];
        list.forEach(item=>{
            if(item.isHas==1){
                hasList.push({
                    value:item[keyValue],
                    label: item[keyLabel],
                })
                valueList.push(item[keyValue])
            }
            children.push({
                value:item[keyValue],
                label: item[keyLabel],
            })
        })
        this.setState({
            optionList: children,
            hasList: hasList,
            valueList : valueList
        })
        if(this.props.onChangeBack)this.props.onChangeBack(valueList)
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const {title,placeholder} = this.props;
        const {optionList,hasList} = this.state;
        return (<div className={"labelSeparateSelect"}>
            {title&&<div className={"black100 mb_8"}>{title}</div>}
            <Select mode="multiple"
                    placement={"topLeft"}
                    value={[]}
                    onChange={(value, option)=>this.handleChange(value, option)}
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    placeholder = {placeholder||Lang({id:"SouSuoGuoJia",default:"搜索国家"})}
                    options={optionList}
                    style={{width:"100%"}}
                />
                <div className={"flex-item"}>
                    {hasList.map((item,inx)=><span className={"label"}
                                                   onClick={()=>this.handleDelete(item.value)}
                                                   key={inx}>{item.label}<i className="ri-close-line ml_16"></i></span>)}
            </div>
        </div>)
    }
}